import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { RouterProvider } from 'react-router';
import { Toaster } from '@eriko/ui/src/components/ui/sonner';
import { router } from './router';

// i18n must be imported before any component that uses useTranslation
import './i18n';

// Initialize theme (light/dark/system) from localStorage
import { initTheme } from './lib/theme';
initTheme();

// Make sure global styles from ui package are imported
import '@eriko/ui/src/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000, // 30 seconds
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="top-right" richColors closeButton />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
